//css
import './index.scss';
import './index.css';

//react
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryProvider } from "./QueryProvider";
import { routes } from "./AppRoutes";
import { ThemeProvider } from "react-bootstrap";

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

// document.documentElement.setAttribute(
//     'data-bs-theme',
//     document.documentElement.getAttribute( 'data-bs-theme' ) === 'dark' ? 'light' : 'dark'
// )

root.render(
    <React.StrictMode>
            <QueryProvider>
                <RouterProvider router={router} />
            </QueryProvider>
    </React.StrictMode>
);
